import React from "react";
import { useNavigate } from "react-router-dom";
import { getLoanAdvantagesText } from "../../utils/loan";
import { getProductImageUrl } from "../../utils/image";

const LoanProductCard = ({ loan }) => {
  const navigate = useNavigate();

  const goToLoanDetail = () => {
    navigate(`/select-loan/${loan.id}`);
  };

  return (
    <div style={{ cursor: "pointer" }} className="bCard">
      <div className="card" onClick={() => goToLoanDetail("pico")}>
        <div className="cardTop">
          <img
            style={{ height: 100, width: "100%", objectFit: "cover" }}
            src={loan.image_url || "/assets/img/ci/img/img-pico-loan.png"}
          ></img>
        </div>
        <div className="cardTitle">
          <p>{loan.name} </p>
        </div>
        {/* advantages hidden */}
      </div>
    </div>
  );
};

export default LoanProductCard;
